import { render } from "./rateSettingsToggle.vue?vue&type=template&id=0254c353&scoped=true"
import script from "./rateSettingsToggle.vue?vue&type=script&lang=js"
export * from "./rateSettingsToggle.vue?vue&type=script&lang=js"

import "./rateSettingsToggle.vue?vue&type=style&index=0&id=0254c353&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0254c353"]])

export default __exports__